module.exports = __webpack_public_path__ + "img/box_pro_one_5.9c873986.jpg";